import {officeSvg as Icon__small__officeSvg} from '../Icon__small/Icon__small--office.js';
import {officeSvg as Icon__xsmall__officeSvg} from '../Icon__xsmall/Icon__xsmall--office.js';

export var office = {
  name: 'office',
  category: 'icon',
  colorable: true,
  svg: Icon__small__officeSvg,
  alt: {
    Icon__small: Icon__small__officeSvg,
    Icon__xsmall: Icon__xsmall__officeSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
